import React, { useState } from 'react';
import {
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate } from 'react-router-dom';

import BlitzHeader from './BlitzHeader';
import routes from '../Config/routes';
import useAuth from '../Hooks/use-auth';
import { useCreatorAuth } from '../Hooks/creator-use-auth';

export default function HomeHeader({ menuButton }) {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const { isAuthorized } = useAuth();
  const { creatorToken } = useCreatorAuth();
  const isCreatorAuthorized = Boolean(creatorToken);

  const handleDashboardRedirect = () => {
    if (isCreatorAuthorized && !isAuthorized) {
      navigate('/creatorconnect/start');
    } else {
      navigate(routes.dashboard);
    }
  };

  /* ---------------- Mobile menu ---------------- */
  const [mobileAnchorEl, setMobileAnchorEl] = useState(null);
  const handleMenuClick = (e) => setMobileAnchorEl(e.currentTarget);
  const closeMobileMenu = () => setMobileAnchorEl(null);

  const jump = (slug) => () => {
    closeMobileMenu();
    navigate(slug);
  };

  return (
    <BlitzHeader
      sx={{ pt: { xs: 'env(safe-area-inset-top)', sm: 0 } }}
      menuButton={menuButton}
    >
      {/* Spacer so logo + nav align nicely */}
      <Box sx={{ height: 50, flexShrink: 0 }} />

      {/* Center navigation */}
      <Box display="flex" alignItems="center" justifyContent="center" flex={1}>
        {isMobile ? (
          <>
            <IconButton color="inherit" onClick={handleMenuClick}>
              <MenuIcon />
            </IconButton>

            {/* Mobile dropdown */}
            <Menu
              anchorEl={mobileAnchorEl}
              open={Boolean(mobileAnchorEl)}
              onClose={closeMobileMenu}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
              transformOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
              <MenuItem onClick={jump(`${routes.solutions}#blitzPay`)}>Pay</MenuItem>
              <MenuItem onClick={jump(`${routes.create}#creatorSourcing`)}>Create</MenuItem>
              <MenuItem
                onClick={jump(`${routes.collaborate}#acceleratedCollaborations`)}
              >
                Collaborate
              </MenuItem>
            </Menu>
          </>
        ) : (
          <>
            <Button
              color="inherit"
              variant="text"
              onClick={jump(`${routes.solutions}#blitzPay`)}
            >
              Pay
            </Button>
            <Button
              color="inherit"
              variant="text"
              onClick={jump(`${routes.create}#creatorSourcing`)}
            >
              Create
            </Button>
            <Button
              color="inherit"
              variant="text"
              onClick={jump(`${routes.collaborate}#acceleratedCollaborations`)}
            >
              Collaborate
            </Button>
          </>
        )}
      </Box>

      {/* Right-hand auth links */}
      <Box
        display="flex"
        justifyContent="end"
        flex={1}
        overflow="visible"
        textAlign="right"
        whiteSpace="nowrap"
        minWidth={0}
      >
        {isAuthorized || isCreatorAuthorized ? (
          <Button color="inherit" variant="text" onClick={handleDashboardRedirect}>
            Back&nbsp;to&nbsp;Blitz
          </Button>
        ) : (
          <>
            <Button
              color="inherit"
              variant="text"
              onClick={() => navigate(routes.login)}
            >
              Login
            </Button>
            <Button
              color="inherit"
              variant="text"
              onClick={() => navigate(routes.onboard)}
            >
              Signup
            </Button>
          </>
        )}
      </Box>
    </BlitzHeader>
  );
}
